<template>
  <alzata-dialog ref="modal" :title="route ? 'Edit Route' : 'Create Route'">
    <div v-if="type === 'Client'">
      <div class="row g-2">
        <div class="col-8">
          <label for="name" class="small">Name</label>
          <input
            id="name"
            type="text"
            class="form-control"
            placeholder="Name"
            v-model="name"
          />
        </div>
        <div class="col-4">
          <label for="component" class="small">Component</label>
          <select id="component" class="form-select" v-model="component">
            <option
              v-for="(thing, idx) in availableRoutes"
              :key="idx"
              :value="thing"
            >
              {{ thing }}
            </option>
          </select>
        </div>
        <div class="col-8">
          <label for="path" class="small">Path</label>
          <input id="path" type="text" class="form-control" v-model="path" />
        </div>
        <div class="col-2">
          <label for="active" class="small">Active</label>
          <div class="form-control border-0">
            <input
              id="active"
              type="checkbox"
              class="form-check-input"
              v-model="isActive"
            />
          </div>
        </div>
        <div class="col-2">
          <label for="visible" class="small">Visible</label>
          <div class="form-control border-0">
            <input
              id="visible"
              type="checkbox"
              class="form-check-input"
              v-model="visible"
            />
          </div>
        </div>
        <div class="col-2" v-if="visible">
          <label for="icon" class="small">Icon</label>
          <alzata-dropdown id="icon" :items="allIcons">
            <template v-slot:label>
              <alzata-icon :icon="icon" fixed-width class="me-1" />
            </template>
            <template v-slot:item="{ item }">
              <span
                class="dropdown-item2 p-1 rounded"
                :class="item === icon ? 'active' : null"
                style="cursor: pointer"
                @click="setIcon(item)"
              >
                <alzata-icon :icon="item" fixed-width />
              </span>
            </template>
          </alzata-dropdown>
        </div>
        <div class="col-8" v-if="visible">
          <label for="label" class="small">Label</label>
          <input
            id="label"
            type="text"
            class="form-control"
            placeholder="Label"
            v-model="label"
          />
        </div>
        <div class="col-2" v-if="visible">
          <label for="order" class="small">Order</label>
          <input id="order" type="text" class="form-control" v-model="order" />
        </div>
        <div class="col-12">
          <label for="access" class="small">Access</label>
          <alzata-acl-editor
            entityTypeId="D1BDDB30-910C-44C1-9E2A-1530F4CFC24E"
            :entityId="route.id"
            v-model="grants"
          />
        </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <button type="button" class="btn btn-link" @click="this.$refs.modal.hide">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" @click="saveRoute">
        Save
      </button>
    </template>
  </alzata-dialog>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";

export default {
  name: "AlzataEditRouteDialog",
  emits: ["save"],
  data() {
    return {
      route: null,
      type: null,
      icon: null,
      label: null,
      name: null,
      path: null,
      component: null,
      order: null,
      isActive: null,
      grants: null,
      availableRoutes: Object.keys(this.$router.pageMap),
      visible: null,
    };
  },
  methods: {
    show(route) {
      this.route = route;
      this.icon = route.icon || "fal/square";
      this.label = route.label;
      this.name = route.name;
      this.type = route.type || "Client";
      this.path = route.relativePath || "";
      this.component = route.component;
      this.order = route.sidebarOrder || 0;
      this.isActive = route.isActive || false;
      this.grants = null;
      this.visible = route.sidebarOrder != null;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    setIcon(icon) {
      this.icon = icon;
    },
    saveRoute() {
      this.$emit("save", {
        id: this.route.id,
        type: this.type,
        icon: this.icon,
        label: this.label,
        name: this.name,
        component: this.component,
        path: this.path,
        order: this.visible ? this.order : undefined,
        isActive: this.isActive,
        grants: this.grants,
      });
    },
  },
  watch: {},
  computed: {
    allIcons() {
      console.log(library);
      return Object.keys(library.definitions)
        .map((x) => Object.keys(library.definitions[x]).map((y) => `${y}/${x}`))
        .flat()
        .sort()
        .map((x) => x.split("/").reverse().join("/"));
    },
  },
};
</script>
